import { eventDetailsService } from 'config/api';
import { addNotification } from 'shell/actions';
import actionTypes from './actionTypes';

export const getEventDetails = (associateId, isSortedByCompleted) => async (dispatch) => {
  dispatch({ type: actionTypes.REASON_TO_CONTACT_LOADING });

  try {
    const res = await eventDetailsService.get(`/rtc/${associateId}`);

    dispatch({
      type: actionTypes.REASON_TO_CONTACT_SUCCESS,
      payload: { ...res.data, isSortedByCompleted },
    });
  } catch (error) {
    dispatch({
      type: actionTypes.REASON_TO_CONTACT_ERROR,
      payload: error,
    });
  }
};

export const getSingleEventDetails = (associateId, timestamp) => async (dispatch) => {
  dispatch({ type: actionTypes.REASON_TO_CONTACT_LOADING });

  try {
    const res = await eventDetailsService.post('/rtcDetails', {
      associateId,
      timestamp,
    });

    dispatch({
      type: actionTypes.REASON_TO_CONTACT_SINGLE_SUCCESS,
      payload: { ...res.data },
    });
  } catch (error) {
    dispatch({
      type: actionTypes.REASON_TO_CONTACT_ERROR,
      payload: error,
    });
  }
};

export const updateEventAction = (action, isSortedByCompleted) => async (dispatch) => {
  try {
    const { associateId } = action;

    const response = await eventDetailsService.post(`/rtc/${associateId}/action`, action);
    dispatch({
      type: actionTypes.REASON_TO_CONTACT_SET_COMPLETED_SUCCESS,
      payload: { ...response, isSortedByCompleted },
    });

    return response;
  } catch (error) {
    dispatch(
      addNotification({
        id: `error-${Date.now()}`,
        message: error.message,
        type: 'error',
      }),
    );

    return error;
  }
};

export const restoreReasonToContactCategory = (categoriesState) => ({
  type: actionTypes.REASON_TO_CONTACT_RESTORE,
  payload: categoriesState,
});
